import React from 'react';

// Material Symbols Rounded "hourglass_top" (outline, FILL 0) — Figma Waitlist 디자인과 동일한 글리프.
const HourglassTopIcon = ({ className }: { className?: string }) => (
  <svg viewBox="0 -960 960 960" fill="currentColor" className={className} aria-hidden="true">
    <path d="M320-160h320v-120q0-66-47-113t-113-47q-66 0-113 47t-47 113v120ZM200-80q-17 0-28.5-11.5T160-120q0-17 11.5-28.5T200-160h40v-120q0-61 28.5-114.5T348-480q-51-32-79.5-85.5T240-680v-120h-40q-17 0-28.5-11.5T160-840q0-17 11.5-28.5T200-880h560q17 0 28.5 11.5T800-840q0 17-11.5 28.5T760-800h-40v120q0 61-28.5 114.5T612-480q51 32 79.5 85.5T720-280v120h40q17 0 28.5 11.5T800-120q0 17-11.5 28.5T760-80H200Z" />
  </svg>
);

export default HourglassTopIcon;
